(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/page-title.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/page-title.js');

'use strict';

const PageTitle = _ref => {
  let isSuppressData = _ref.isSuppressData,
    children = _ref.children;
  return React.createElement("div", {
    className: "h1 f-900 align-left padding-xs-top-1 margin-bottom-2".concat(isSuppressData ? ' data-hj-suppress' : '')
  }, React.createElement("span", {
    className: "f-medium"
  }, children));
};
svs.playerRegistration.components.PageTitle = PageTitle;

 })(window);